import { useEffect } from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {
    DocumentTypeRuleTestRequest,
    DocumentTypeRule,
} from "../../../../models";
import { DocumentRulesService } from "../../../../services/ClientService";

export type DocumentTypeRuleTestModalProps = {
    show: boolean;
    attorneyId?: string;
    county?: string;
    division?: string;
    ruleId?: string;
    filename?: string;
    fileText?: string;
    claimAmount?: number;
    newCases?: boolean;
    data?: DocumentTypeRule;
    onSubmit: () => void;
    onClose: () => void;
};

export default function DocumentTypeRuleTestModal({
    show,
    attorneyId,
    county,
    division,
    filename,
    fileText,
    claimAmount,
    newCases,
    onSubmit,
    onClose,
}: DocumentTypeRuleTestModalProps) {
    const [rule, setRule] = useState({
        attorneyID: attorneyId,
        county: county,
        division: division,
        filename: filename,
        fileText: fileText,
        claimAmount: claimAmount,
        newCases: newCases,
    } as DocumentTypeRuleTestRequest);

    const [data, setData] = useState("");
    const [submitted, setSubmitted] = useState<boolean>(false);

    useEffect(() => {
        setRule({
            attorneyID: attorneyId,
            county: county,
            division: division,
            filename: filename,
            fileText: fileText,
            claimAmount: claimAmount,
            newCases: newCases,
        });
    }, [
        show,
        attorneyId,
        county,
        division,
        filename,
        fileText,
        claimAmount,
        newCases,
    ]);

    useEffect(() => {
        console.log({ data: data });
        if (data && submitted) {
            alert(data);
        }
    }, [data]);

    const submitRule = () => {
        DocumentRulesService.getRule({
            body: {
                ...rule,
            },
        }).then(
            (resp) => {
                setSubmitted(true);
                if (resp.data && resp.successful) {
                    if (resp.data === null) {
                        setData("No Rule Found");
                    }
                    const pretty = JSON.stringify(resp.data, null, 4);
                    setData(pretty);
                } else {
                    if (resp.errorMessage === null) {
                        setData("No Rule Found");
                        return;
                    }
                    setData("An Server Error Occured: " + resp.errorMessage);
                }
            },
            (error) => {
                setData("A Client Error Occured: " + error.message);
            }
        );
    };

    const closeWindow = () => {
        setData("");
        setSubmitted(false);
        onClose();
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Document Type Rule Test
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row form-group m-2">
                    <div className="col-sm-6">
                        <label>Attorney ID</label>
                        <input
                            className="form-control"
                            id="docTypeRuleAttorneyID"
                            type="text"
                            defaultValue={rule.attorneyID}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    attorneyID: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-6">
                        <label>County</label>
                        <input
                            className="form-control"
                            id="docTypeRuleCounty"
                            type="text"
                            defaultValue={rule.county}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    county: event.currentTarget.value,
                                })
                            }
                        />
                    </div>

                    <div className="col-sm-6">
                        <label>Division</label>
                        <input
                            className="form-control"
                            id="docTypeRuleDivision"
                            type="text"
                            defaultValue={rule.division}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    division: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Filename</label>
                        <input
                            className="form-control"
                            id="docTypeRuleFilename"
                            type="text"
                            defaultValue={rule.filename}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    filename: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>File Text</label>
                        <input
                            className="form-control"
                            id="docTypeRuleFileText"
                            type="text"
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    fileText: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Claim Amount</label>
                        <input
                            className="form-control"
                            id="docTypeRuleClaimAmount"
                            type="number"
                            defaultValue={0}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    claimAmount: parseFloat(
                                        event.currentTarget.value
                                    ),
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>New Cases</label>
                        <input
                            className="form-control"
                            id="docTypeRuleDocType"
                            type="text"
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    newCases:
                                        event.currentTarget.value == "true"
                                            ? true
                                            : false,
                                })
                            }
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-danger" onClick={() => closeWindow()}>
                    Cancel
                </Button>
                <Button onClick={submitRule}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
}
